var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4.75C10.75 4.55109 10.671 4.36032 10.5303 4.21967C10.3897 4.07902 10.1989 4 10 4C9.80109 4 9.61032 4.07902 9.46967 4.21967C9.32902 4.36032 9.25 4.55109 9.25 4.75V9.25H4.75C4.55109 9.25 4.36032 9.32902 4.21967 9.46967C4.07902 9.61032 4 9.80109 4 10C4 10.1989 4.07902 10.3897 4.21967 10.5303C4.36032 10.671 4.55109 10.75 4.75 10.75H9.25V15.25C9.25 15.4489 9.32902 15.6397 9.46967 15.7803C9.61032 15.921 9.80109 16 10 16C10.1989 16 10.3897 15.921 10.5303 15.7803C10.671 15.6397 10.75 15.4489 10.75 15.25V10.75H15.25C15.4489 10.75 15.6397 10.671 15.7803 10.5303C15.921 10.3897 16 10.1989 16 10C16 9.80109 15.921 9.61032 15.7803 9.46967C15.6397 9.32902 15.4489 9.25 15.25 9.25H10.75V4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlusIcon);
export default __webpack_public_path__ + "static/media/whitePlusIcon.a67f7a139c2aa7b370c5fdc1d1aee2a6.svg";
export { ForwardRef as ReactComponent };